import styled from "styled-components";
import {Avatar, Form} from "antd";

export const MapContainer = styled.div`
    height: 250px;
    overflow: auto;
    margin: 20px 0;
    border-radius: 4px;
    pointer-events: ${props => props.disabled && "none"};
    position: relative;
`;

export const Marker = styled(Avatar)`
    position: "absolute";
    background-color: #021529;
    transform: translate(-50%, -50%);
    font-size: 16px !important;
    width: 30px;
    height: 30px;
`;

export const FormItem = styled(Form.Item)`
    margin: 0;
`;

export const DisableMapContainer = styled.div`
    background: #9a9a9a7a;
    height: 250px;
    position: absolute;
    width: 100%;
    margin: 20px 0;
    z-index: 2;

    cursor: not-allowed;
`;
